import { useMemo } from "react";
import { partition } from "@common/helpers/collections";
import { useEntities } from "./useEntities";
import { ExcludeEmptyMockEntitiesMode } from "./useEntitiesContexts";

export function useFinancialAccountEntitySelection() {
    const availableEntities = useEntities({
        excludeEmptyMockEntities: ExcludeEmptyMockEntitiesMode.NEVER,
    });

    const [businessEntities, personalEntities] = useMemo(
        () => partition(availableEntities, (e) => e.isBusiness),
        [availableEntities],
    );

    return useMemo(
        () => ({
            businessEntities,
            personalEntities,
            showBusinessEntitySelection: true,
            showPersonalEntitySelection: personalEntities.length !== 1,
            nonMockBusinessEntities: businessEntities.filter(
                (e) => !e.isMockEntity,
            ),
        }),
        [businessEntities, personalEntities],
    );
}
